module.exports = __webpack_public_path__ + "20260611d121505t/img/ewm2.25bff2fe.png";